<div class="card">
	<!-- Status Cards Section -->
	<div class="card-header border-0 pt-6 pb-2">
		<div class="row w-100 mb-4 status-cards">
			<div class="col-md-4">
				<div class="card bg-light-primary border-0 h-100" [ngClass]="{'status-card-loading': isLoading}">
					<div class="card-body d-flex align-items-center py-4">
						<div class="symbol symbol-50px me-4">
							<div class="symbol-label bg-primary">
								<i class="ki-duotone ki-people fs-2 text-white">
									<span class="path1"></span>
									<span class="path2"></span>
									<span class="path3"></span>
									<span class="path4"></span>
									<span class="path5"></span>
								</i>
							</div>
						</div>
						<div class="flex-grow-1">
							<div class="text-dark fw-bold fs-6 mb-1">All Members</div>
							<div class="text-primary fw-bolder fs-2">{{ totalClients | number }}</div>
						</div>
					</div>
				</div>
			</div>
			<div class="col-md-4">
				<div class="card bg-light-danger border-0 h-100" [ngClass]="{'status-card-loading': isLoading}">
					<div class="card-body d-flex align-items-center py-4">
						<div class="symbol symbol-50px me-4">
							<div class="symbol-label bg-danger">
								<i class="ki-duotone ki-cross-circle fs-2 text-white">
									<span class="path1"></span>
									<span class="path2"></span>
								</i>
							</div>
						</div>
						<div class="flex-grow-1">
							<div class="text-dark fw-bold fs-6 mb-1">Blocked</div>
							<div class="text-danger fw-bolder fs-2">{{ blockedCount | number }}</div>
						</div>
					</div>
				</div>
			</div>
			<div class="col-md-4">
				<div class="card bg-light-success border-0 h-100" [ngClass]="{'status-card-loading': isLoading}">
					<div class="card-body d-flex align-items-center py-4">
						<div class="symbol symbol-50px me-4">
							<div class="symbol-label bg-success">
								<i class="ki-duotone ki-check-circle fs-2 text-white">
									<span class="path1"></span>
									<span class="path2"></span>
								</i>
							</div>
						</div>
						<div class="flex-grow-1">
							<div class="text-dark fw-bold fs-6 mb-1">Permitted</div>
							<div class="text-success fw-bolder fs-2">{{ permittedCount | number }}</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>

	<div class="card-header border-0 pt-0">
		<div class="card-form fw-row row" *ngIf="showClientFiltersForm">
			<div class="col-md-2 mb-10">
				<label class="form-label fs-6 fw-semibold w-100">Rating</label>
				<div class="d-flex gap-4">
					<div class="form-check form-check-sm form-check-custom form-check-solid">
						<input type="checkbox" class="form-check-input" value="" id="ratingGold" />
						<label class="form-check-label" for="ratingGold">Gold</label>
					</div>
					<div class="form-check form-check-sm form-check-custom form-check-solid">
						<input type="checkbox" class="form-check-input" value="" id="ratingSilver" />
						<label class="form-check-label" for="ratingSilver">Silver</label>
					</div>
					<div class="form-check form-check-sm form-check-custom form-check-solid">
						<input type="checkbox" class="form-check-input" value="" id="ratingPlatinum" />
						<label class="form-check-label" for="ratingPlatinum">Platinum</label>
					</div>
				</div>
			</div>
			<div class="col-md-2 mb-10">
				<label class="form-label fs-6 fw-semibold w-100">Status</label>
				<div class="d-flex gap-4">
					<div class="form-check form-check-sm form-check-custom form-check-solid">
						<input type="checkbox" class="form-check-input" value="" id="statusBlocked" />
						<label class="form-check-label" for="statusBlocked">Blocked</label>
					</div>
					<div class="form-check form-check-sm form-check-custom form-check-solid">
						<input type="checkbox" class="form-check-input" value="" id="statusPermitted" />
						<label class="form-check-label" for="statusPermitted">Permitted</label>
					</div>
				</div>
			</div>
			<div class="col-md-2 mb-10">
				<label class="form-label fs-6 fw-semibold w-100">Bid Permission</label>
				<div class="d-flex gap-4">
					<div class="form-check form-check-sm form-check-custom form-check-solid">
						<input type="radio" class="form-check-input" value="" name="bidPermission"
							id="bidPermissionYes" />
						<label class="form-check-label" for="bidPermissionYes">Yes</label>
					</div>
					<div class="form-check form-check-sm form-check-custom form-check-solid">
						<input type="radio" class="form-check-input" value="" name="bidPermission"
							id="bidPermissionNo" />
						<label class="form-check-label" for="bidPermissionNo">No</label>
					</div>
				</div>
			</div>
			<div class="col-md-2 mb-10">
				<label class="form-label fs-6 fw-semibold w-100">USS Permission</label>
				<div class="d-flex gap-4">
					<div class="form-check form-check-sm form-check-custom form-check-solid">
						<input type="radio" class="form-check-input" value="" name="ussPermission"
							id="ussPermissionYes" />
						<label class="form-check-label" for="ussPermissionYes">Yes</label>
					</div>
					<div class="form-check form-check-sm form-check-custom form-check-solid">
						<input type="radio" class="form-check-input" value="" name="ussPermission"
							id="ussPermissionNo" />
						<label class="form-check-label" for="ussPermissionNo">No</label>
					</div>
				</div>
			</div>
			<div class="col-md-2 mb-10">
				<label class="form-label fs-6 fw-semibold w-100">Bid Mail Permission</label>
				<div class="d-flex gap-4">
					<div class="form-check form-check-sm form-check-custom form-check-solid">
						<input type="radio" class="form-check-input" value="" name="bidMailPermission"
							id="bidMailPermissionYes" />
						<label class="form-check-label" for="bidMailPermissionYes">Yes</label>
					</div>
					<div class="form-check form-check-sm form-check-custom form-check-solid">
						<input type="radio" class="form-check-input" value="" name="bidMailPermission"
							id="bidMailPermissionNo" />
						<label class="form-check-label" for="bidMailPermissionNo">No</label>
					</div>
				</div>
			</div>
			<div class="col-md-2 mb-10">
				<label class="form-label fs-6 fw-semibold w-100">Show CIF</label>
				<div class="d-flex gap-4">
					<div class="form-check form-check-sm form-check-custom form-check-solid">
						<input type="radio" class="form-check-input" value="" name="showCIF" id="showCIFYes" />
						<label class="form-check-label" for="showCIFYes">Yes</label>
					</div>
					<div class="form-check form-check-sm form-check-custom form-check-solid">
						<input type="radio" class="form-check-input" value="" name="showCIF" id="showCIFNo" />
						<label class="form-check-label" for="showCIFNo">No</label>
					</div>
				</div>
			</div>
			<div class="col-md-2 mb-10">
				<label class="form-label fs-6 fw-semibold w-100">Is Broker</label>
				<div class="d-flex gap-4">
					<div class="form-check form-check-sm form-check-custom form-check-solid">
						<input type="radio" class="form-check-input" value="" name="isBroker" id="isBrokerYes" />
						<label class="form-check-label" for="isBrokerYes">Yes</label>
					</div>
					<div class="form-check form-check-sm form-check-custom form-check-solid">
						<input type="radio" class="form-check-input" value="" name="isBroker" id="isBrokerNo" />
						<label class="form-check-label" for="isBrokerNo">No</label>
					</div>
				</div>
			</div>
			<div class="col-md-2 mb-10">
				<label class="form-label fs-6 fw-semibold w-100">Sales Stats. Permission</label>
				<div class="d-flex gap-4">
					<div class="form-check form-check-sm form-check-custom form-check-solid">
						<input type="radio" class="form-check-input" value="" name="statsPermission"
							id="statsPermissionYes" />
						<label class="form-check-label" for="statsPermissionYes">Yes</label>
					</div>
					<div class="form-check form-check-sm form-check-custom form-check-solid">
						<input type="radio" class="form-check-input" value="" name="statsPermission"
							id="statsPermissionNo" />
						<label class="form-check-label" for="statsPermissionNo">No</label>
					</div>
				</div>
			</div>
			<div class="col-md-2 mb-10">
				<label for="cmlRegistrationDate" class="form-label fs-7 fw-semibold  mb-2">Registered Date</label>
				<div class="d-flex align-items-center gap-2">
					<input type="date" class="form-control form-control-sm w-125px" id="cmlRegistrationDateFrom"
						name="cmlRegistrationDate" />
					<span> - </span>
					<input type="date" class="form-control form-control-sm w-125px" id="cmlRegistrationDateTo"
						name="cmlRegistrationDate" />
				</div>
			</div>
			<div class="col-md-2 mb-10">
				<label for="cmlSalesPerson" class="form-label fs-7 fw-semibold  mb-2">Sales Person</label>
				<select class="form-select form-select-sm" id="cmlSalesPerson" name="cmlSalesPerson">
					<option value="" disabled selected>Select</option>
					<option *ngFor="let person of salesPersonList" [value]="person.value">{{ person.label }}</option>
				</select>
			</div>
			<div class="col-md-4 mb-10">
				<label for="cmlKeyword" class="form-label fs-7 fw-semibold  mb-2">Keyword</label>
				<input type="text" class="form-control form-control-sm" id="cmlKeyword" name="cmlKeyword"
					placeholder="Email, Login ID, Name, City, Phone, Country" />
			</div>
			<div class="col-md-2 mb-10">
				<label class="form-label fs-6 fw-semibold w-100">&nbsp;</label>
				<button type="button" class="btn btn-sm btn-primary me-3 text-nowrap">
					<span>Apply</span>
				</button>
				<button type="button" class="btn btn-sm btn-dark text-nowrap">
					<span>Reset</span>
				</button>
			</div>
		</div>
		<div class="card-title">
			<div class="d-flex align-items-center position-relative my-1">
				<i class="ki-duotone ki-magnifier fs-3 position-absolute ms-5">
					<span class="path1"></span>
					<span class="path2"></span>
				</i>
				<input type="text" class="form-control form-control-sm w-250px ps-12" placeholder="Search"
					(input)="onSearch($event)" [value]="searchTerm" />
			</div>
		</div>
		<div class="card-toolbar">
			<div class="d-flex justify-content-end" data-table-toolbar="base">
				<button type="button" class="btn btn-sm btn-outline me-3 text-nowrap"
					[ngClass]="showClientFiltersForm ? 'btn-primary' : 'btn-dark'" (click)="toggleClientFiltersForm()">
					<i class="ki-duotone fs-2" [ngClass]="showClientFiltersForm ? 'ki-minus' : 'ki-filter'">
						<span class="path1"></span>
						<span class="path2"></span>
					</i>
					<span>Filter</span>
				</button>
				<button type="button" class="btn btn-sm btn-dark me-3 text-nowrap" data-bs-toggle="modal"
					data-bs-target="#kt_export_modal">
					<i class="ki-duotone ki-exit-up fs-2">
						<span class="path1"></span>
						<span class="path2"></span>
					</i>
					<span>Export</span>
				</button>
				<button type="button" class="btn btn-sm btn-success me-3" (click)="addClient()">
					<i class="ki-duotone ki-plus fs-2">
						<span class="path1"></span>
						<span class="path2"></span>
						<span class="path3"></span>
					</i>Add Client
				</button>

				<!-- <div class="w-100">
					<select class="form-select form-select-sm" data-hide-search="true" data-placeholder="Status" (change)="onStatusFilterChange($event)" [value]="selectedStatusFilter">
						<option value="" disabled>Members</option>
						<option value="all">All Members ({{ totalClients }})</option>
						<option value="blocked">Blocked ({{ blockedCount }})</option>
						<option value="permitted">Permitted ({{ permittedCount }})</option>
					</select>
				</div> -->
			</div>
			<div class="d-flex justify-content-end align-items-center d-none" data-table-toolbar="selected">
				<div class="fw-bold me-5">
					<span class="me-2" data-table-select="selected_count"></span>Selected
				</div>
				<button type="button" class="btn btn-sm btn-dark" data-table-select="delete_selected">Delete
					Selected</button>
			</div>
		</div>
	</div>
	<div class="card-body pt-0">
		<table class="table align-middle table-bordered fs-6 rounded-3 overflow-hidden"
			id="kt_table_client_manager_list">
			<thead>
				<tr class="text-start text-muted fw-bold fs-7 text-uppercase bg-primary-subtle">
					<th class="text-nowrap">
						<div class="form-check form-check-sm form-check-custom form-check-solid me-3">
							<input type="checkbox" class="form-check-input" data-kt-check="true"
								data-kt-check-target="#kt_table_client_manager_list .invoice-number-check" value="1" />
						</div>
					</th>
					<th class="text-nowrap">Member Details</th>
					<th class="text-nowrap">Login ID/Password</th>
					<th class="text-nowrap">Register Date</th>
					<th class="text-nowrap">Permissions</th>
					<th class="text-nowrap">Member Status</th>
					<th class="text-nowrap">Actions</th>
				</tr>
			</thead>
			<tbody class="text-gray-600 fw-semibold">
				<!-- Loading Row -->
				<tr *ngIf="isLoading">
					<td colspan="7" class="text-center py-10">
						<div class="d-flex align-items-center justify-content-center">
							<div class="spinner-border spinner-border-sm text-primary me-2" role="status">
								<span class="visually-hidden">Loading...</span>
							</div>
							Loading clients...
						</div>
					</td>
				</tr>

				<!-- No Data Row -->
				<tr *ngIf="!isLoading && clients.length === 0">
					<td colspan="7" class="text-center py-10">
						<div class="text-muted">No clients found</div>
					</td>
				</tr>

				<!-- Client Rows -->
				<tr *ngFor="let client of clients; trackBy: trackByClientId">
					<td class="text-nowrap">
						<div class="form-check form-check-sm form-check-custom form-check-solid">
							<input type="checkbox" class="form-check-input invoice-number-check"
								[value]="client._id || client.doc_id" />
						</div>
					</td>
					<td class="text-nowrap">
						<b>{{ client.name }}</b>
						<br>
						{{ client.prefix }} {{ client.name }}
						<br>
						<br>
						Country : {{ client.country }}
						<br>
						Tel/Mobile: {{ client.phone || client.mobile }}
						<br>
						<br>
						<!-- <button type="button" class="btn btn-sm btn-outline btn-outline-primary">DHL Details</button> -->
					</td>
					<td class="text-nowrap">
						<b>Email/Login id : {{ client.email }}</b>
						<br>
						Password : ********
						<br>
						<br>
						Currency: {{ client.currency_type?.toUpperCase() || 'USD' }}
						<br>
						<br>
						<!-- <button type="button" class="btn btn-sm btn-outline btn-outline-primary me-3">Create</button>
						<button type="button" class="btn btn-sm btn-outline btn-outline-primary me-3">Invoice</button>
						<button type="button"
							class="btn btn-sm btn-outline btn-outline-primary me-3">Allocation</button>
						<br>
						<br> -->
						<button type="button" class="btn btn-sm btn-outline btn-outline-primary me-3"
							(click)="loginAsClient(client)"
							[disabled]="loginAsClientLoadingId === (client._id || client.doc_id)">
							<span *ngIf="loginAsClientLoadingId === (client._id || client.doc_id)"
								class="spinner-border spinner-border-sm me-1" role="status">
								<span class="visually-hidden">Loading...</span>
							</span>
							Login As Client
						</button>
						<button type="button" (click)="openBidHistory(client._id)" class="btn btn-sm btn-outline btn-outline-primary me-3">BID
							History</button>
						<!-- <button type="button" class="btn btn-sm btn-outline btn-outline-primary me-3">My
							Account</button> -->
					</td>
					<td class="text-nowrap">
						{{ client.created_at | date:'dd MMMM, yyyy' }}
						<br>
						<br>
						IP : N/A
						<br>
						<br>
						Sales Person: {{ client.sales_person || 'N/A' }}
					</td>
					<td class="text-nowrap">
						Broker : <span [ngClass]="client.permissions?.broker ? 'text-success' : 'text-danger'">{{
							client.permissions?.broker ? 'Yes' : 'No' }}</span>
						<br>
						Auction : <span [ngClass]="client.permissions?.auction ? 'text-success' : 'text-danger'">{{
							client.permissions?.auction ? 'Yes' : 'No' }}</span>
						<br>
						USS : <span [ngClass]="client.permissions?.uss ? 'text-success' : 'text-danger'">{{
							client.permissions?.uss ? 'Yes' : 'No' }}</span>
						<br>
						USS Image : {{ client.permissions?.uss_image || 0 }}
						<br>
						Bids : <span [ngClass]="client.permissions?.bids ? 'text-success' : 'text-danger'">{{
							client.permissions?.bids ? 'Yes' : 'No' }}</span>
						<br>
						Sales Stats. : <span
							[ngClass]="client.permissions?.sales_stats ? 'text-success' : 'text-danger'">{{
							client.permissions?.sales_stats ? 'Yes' : 'No' }}</span>
						<br>
						Show Cif : <span [ngClass]="client.permissions?.show_cif ? 'text-success' : 'text-danger'">{{
							client.permissions?.show_cif ? 'Yes' : 'No' }}</span>
					</td>
					<td [attr.data-order]="client.status">
						<div class="badge"
							[ngClass]="client.status === 'permitted' ? 'badge-light-success' : 'badge-light-danger'">
							{{ client.status | titlecase }}
						</div>
						<br>
						<br>
						<div class="d-flex flex-column gap-4">
							<div class="form-check form-check-sm form-check-custom form-check-solid">
								<input type="radio" class="form-check-input" [value]="'blocked'"
									[name]="'status_' + (client._id || client.doc_id)"
									[id]="'statusBlocked_' + (client._id || client.doc_id)"
									[checked]="client.status === 'blocked'" />
								<label class="form-check-label"
									[for]="'statusBlocked_' + (client._id || client.doc_id)">Blocked</label>
							</div>
							<div class="form-check form-check-sm form-check-custom form-check-solid">
								<input type="radio" class="form-check-input" [value]="'permitted'"
									[name]="'status_' + (client._id || client.doc_id)"
									[id]="'statusPermitted_' + (client._id || client.doc_id)"
									[checked]="client.status === 'permitted'" />
								<label class="form-check-label"
									[for]="'statusPermitted_' + (client._id || client.doc_id)">Permitted</label>
							</div>
						</div>
					</td>
					<td class="text-end">
						<div class="d-flex justify-content-end">
							<!-- Edit Button -->
							<button type="button" class="btn btn-icon btn-sm btn-light-primary me-2"
								(click)="editClient(client); $event.preventDefault()" title="Edit Client">
								<i class="ki-duotone ki-pencil fs-4">
									<span class="path1"></span>
									<span class="path2"></span>
								</i>
							</button>

							<!-- Delete Button -->
							<button type="button" class="btn btn-icon btn-sm btn-light-danger"
								 title="Delete Client">
								<i class="ki-duotone ki-trash fs-4">
									<span class="path1"></span>
									<span class="path2"></span>
									<span class="path3"></span>
									<span class="path4"></span>
									<span class="path5"></span>
								</i>
							</button>
						</div>
					</td>
					<!-- <td class="text-nowrap">
						<a href="#" class="btn btn-light btn-active-light-primary btn-sm" data-kt-menu-trigger="click"
							data-kt-menu-placement="bottom-end">Actions
							<i class="ki-duotone ki-down fs-5 m-0"></i>
						</a>
						<div class="menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 menu-state-bg-light-primary fw-semibold fs-7 w-125px py-4"
							data-kt-menu="true">
							<div class="menu-item px-3">
								<a href="#" class="menu-link px-3"
									(click)="editClient(client); $event.preventDefault()">Edit</a>
							</div>
							<div class="menu-item px-3">
								<a href="#" data-table-filter="delete_row" class="menu-link px-3">Delete</a>
							</div>
						</div>
					</td> -->
				</tr>
			</tbody>
		</table>
	</div>

	<!-- Pagination Component -->
	<app-pagination [paginationInfo]="paginationInfo" [loading]="isLoading" (pageChange)="onPageChange($event)">
	</app-pagination>
</div>
